import SectionHeading from "@/components/base/SectionHeading";
import Tag from "@/components/base/Tag";
import Reveal from "@/components/base/Reveal";
import { featuredEvents } from "@/mocks/homeData";

export default function FeaturedGrid() {
  const large = featuredEvents.find((item) => item.size === "large");
  const smalls = featuredEvents.filter((item) => item.size === "small");

  return (
    <section id="featured" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          eyebrow="热门实锤"
          eyebrowIcon="ri-fire-line"
          title="本周被反复翻出来的几个现场"
          desc="大事件给大版面，短线索用小卡摆在一起。图片和文字各占一半，先看画面，再看结论从哪来。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-4">
          {large ? (
            <Reveal className="sm:col-span-2 lg:col-span-2 lg:row-span-2">
              <a
                href="#featured"
                className="group relative block h-full min-h-[360px] cursor-pointer overflow-hidden rounded-lg lg:min-h-[560px]"
              >
                <img
                  src={large.image}
                  alt="本周头号实锤 · 夜航船阿泽口播事故时间线"
                  title="黑料国产 主播翻车实锤时间线"
                  className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/45 to-black/10"></div>
                <div className="relative flex h-full flex-col justify-end p-5 md:p-7">
                  <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-fire-fill"></i>
                    </span>
                    {large.tag}
                  </span>
                  <h3 className="font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                    {large.title}
                  </h3>
                  <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-200 sm:block">
                    {large.summary}
                  </p>
                  <div className="mt-5 flex flex-wrap items-center gap-4 text-xs text-background-300">
                    <span>{large.source}</span>
                    <span className="h-3 w-px bg-white/20"></span>
                    <span>{large.time}</span>
                    <span className="h-3 w-px bg-white/20"></span>
                    <span>{large.stat}</span>
                  </div>
                </div>
              </a>
            </Reveal>
          ) : null}

          {smalls.map((item, index) => (
            <Reveal key={item.id} delay={index * 70}>
              <a
                href="#featured"
                className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              >
                <div className="h-40 w-full overflow-hidden md:h-44">
                  <img
                    src={item.image}
                    alt={`${item.tag} · ${item.title}`}
                    title="黑料国产 网红事件现场记录"
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-4">
                  <Tag variant="accent">{item.tag}</Tag>
                  <h3 className="mt-2.5 text-sm font-medium leading-6 text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
                  <div className="mt-auto flex items-center justify-between pt-4 text-[11px] text-secondary-600">
                    <span>{item.time}</span>
                    <span className="flex items-center gap-1">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-eye-line"></i>
                      </span>
                      {item.stat}
                    </span>
                  </div>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}